/*
version 0.0.1
 */

import EventBus from './EventBus.ts';
const emitter = EventBus();
class wsPush {

    constructor (options) {
        this.options = {
            forcePoll: false,
            HBRetry: 10, //HB无响应次数后，降级
        };
        this.ws = null;
        this.token = null;
        this.msgSeqId = null;
        this.interval = null;
        this.options = Object.assign(this.options, options);
        // 将on和off暴露出去
        this.on = emitter.on;
        this.off = emitter.off;
        if (this.options.forcePoll || !('WebSocket' in window) || !this.options.url) {
            throw new Error('WebSocket 强制降级')
        } else {
            const url = `${this.options.url}?appkey=${this.options.appkey}&userId=${this.options.bizAccountId}`
            this.start(url);
        }
    }
    start(url) {
        try {
            this.ws = new WebSocket(url);
            this.ws.addEventListener('message', this.processMessage.bind(this));
            this.ws.addEventListener('open', this.register.bind(this));
            this.ws.addEventListener('error', this.poll.bind(this, 'Connect failed'));
            this.ws.addEventListener('close', this.close.bind(this));
        }
        catch (e) {
            // 将错误跑出去
            throw new Error('创建Socket失败')
        }
    }
    register(evt) {
        this.sendMsg('register');
    }
    processMessage(evt) {
        // ACK不做任何处理
        if (evt.data === 'ACK') return;
        try {
            const result = JSON.parse(evt.data);
            switch (result.statMsg) {
                case 'REGISTER OK':
                    this.token = result.token;
                    this.sendMsg('pull', {token: this.token});
                    break;
                case 'PULL OK':
                    this.msgSeqId = result.msgSeqId;
                    emitter.emit('msg', result.msgData);
                    // pull成功后保持心跳，持续发心跳包
                    if (!this.interval) {
                        this.interval = setInterval(()=>{
                            this.sendMsg('HB', {token: this.token});
                            this.options.HBRetry --;
                            if (this.options.HBRetry <= 0) {
                                this.poll('HB out')
                            }
                        }, 30000)
                    }
                    break;
                case 'PUSH OK':
                    if (result.msgSeqId)
                        this.msgSeqId = result.msgSeqId;
                    emitter.emit('msg', result.msgData);
                    this.sendMsg('ack', {token: this.token, msgSeqId: this.msgSeqId});
                    break;
                case 'HB_ACK':
                    this.options.HBRetry ++;
                    break;
                case 'ACK':
                    break; // PUSH的ack的ack，不做处理
                case 'Need Re-rigister':
                    this.sendMsg('register'); //重新注册
                    break;
                default:
                    console.log('未监听Error：', evt)
            }
        } catch (e) {
            console.log(e);
            this.poll('catch error');
        }
    }
    sendMsg(cmd, content = {}) {
        const basic = {
            appkey: this.options.appkey,
            bizAccountId: this.options.bizAccountId,
            cmd,
        };
        const str = JSON.stringify(Object.assign(basic, content));
        this.ws.send(str)
    }
    close(evt) {
        this.poll('closed');
    }
    poll(message) {
        // 降级
        emitter.emit('poll', message);
        // 停止循环HB
        if (this.interval) window.clearInterval(this.interval);
        this.ws.close();
    }
}

export default wsPush


// WEBPACK FOOTER //
// ./src/utils/WebSocketMesssage.js